import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import './attendanceRequests.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';
import { Spinner, Alert } from 'react-bootstrap';

const AttendanceRequests = ({ adminIds, empRole }) => {
  // console.log("attendance Emp role", empRole)

  const { t } = useTranslation();

  useEffect(() => {
    //console.log("Employee IDs managed by the logged-in user attendanceee:", adminIds);
  }, [adminIds]);

  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState('All');
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    setLoading(true);
    const fetchAttendanceRequests = async () => {
      try {
        const response = await axiosInstance.get('/admin/attendance-requests');
        let filteredRequests;

        if (empRole === 'SuperAdmin') {
          // Set all attendance requests for SuperAdmin, excluding 'withdrawn'
          filteredRequests = response.data.filter(request => request.status !== 'Withdrawn');
        } else if (adminIds.length > 0) {
          // Filter attendance requests based on adminIds and exclude 'withdrawn'
          filteredRequests = response.data.filter(request =>
            adminIds.includes(parseInt(request.employee_id)) && request.status !== 'Withdrawn'
          );
        } else {
          filteredRequests = [];
        }

        //console.log("Response data:", response.data); // Log response data for debugging
        //console.log("Filtered requests:", filteredRequests); // Log filtered requests for debugging
        setRequests(filteredRequests.map(formatDateAndStatus));
      } catch (error) {
        // Check if error response is available
        if (!error.response) {
          // Network error or no response
          toast.error("Looks like you are offline. Please check your internet connectivity.");
        } else {
          console.error('Error fetching attendance requests:', error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAttendanceRequests();
  }, [adminIds, empRole]); // Add empRole as a dependency


  const formatDateAndStatus = (request) => {
    const formattedDate = new Date(request.request_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    return { ...request, request_date: formattedDate, status: request.request_status || 'Pending' };
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredRequests = filter === 'All' ? requests : requests.filter(request => request.status === filter);

  const handleAccept = (id, emp_id, name, request_date) => {
    //console.log("requee", request_date);

    // Parse the input date
    const inputDate = new Date(request_date);

    // Format the date to YYYY-MM-DD using toLocaleDateString
    const formattedDate = inputDate.toLocaleDateString('en-CA');

    // Output the formatted date
    //console.log("Request Date:", formattedDate);

    axiosInstance.put(`/admin/attendance-requests/approve/${id}`)
      .then(response => {
        if (response.status === 200) {
          const updatedRequests = requests.map(request => {
            if (request.id === id) {
              return { ...request, status: 'Approved' };
            }
            return request;
          });
          setRequests(updatedRequests);


          // Once the request is approved, update the attendance in the emp_attendance table
          axiosInstance.put('/admin/attendanceRequests/updateAttendance', { emp_id, request_date: formattedDate })
            .then(response => {
              //console.log('Attendance request approved and updated in emp_attendance table');
            })
            .catch(error => {
              console.error('Error updating attendance after approval:', error);
            });
        }
      })
      .catch(error => {
        console.error('Error approving attendance request:', error);
      });
  };

  const handleDecline = (id) => {
    axiosInstance.put(`/admin/attendance-requests/decline/${id}`)
      .then(response => {
        if (response.status === 200) {
          const updatedRequests = requests.map(request => {
            if (request.id === id) {
              return { ...request, status: 'Declined' };
            }
            return request;
          });
          setRequests(updatedRequests);
        }
      })
      .catch(error => {
        console.error('Error declining attendance request:', error);
      });
  };

  return (
    <div className="attendance-requests">

      <h2 className='pgTitle'>{t("attendanceRequest_title")}</h2>

      <div className="filter-container">
        <select id="filter" value={filter} onChange={handleFilterChange}>
          <option value="All">{t("approval_all")}</option>
          <option value="Pending">{t("Pending")}</option>
          <option value="Approved">{t("Approved")}</option>
          <option value="Declined">{t("Declined")}</option>
          {/* <option value="Withdrawn">{t("Withdrawn")}</option> */}
        </select>
      </div>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>{t("projectDetails_EmployeeID")}</th>
              <th>{t("attendance_name")}</th>
              <th>{t("approval_reason")}</th>
              <th>{t("employeeWorkDetails_date")}</th>
              <th>{t("approval_status")}</th>
              <th>{t("approval_action")}</th>
            </tr>
          </thead>
          <tbody style={{ background: '#fff' }}>
            {loading ? (
              <tr>
                <td className='table-data-row'></td>
                <td className='table-data-row'></td>
                <td colSpan={2} className="employee-table-Spinner centered">
                  <Spinner animation="border" role="status">
                    <span className=""></span>
                  </Spinner>
                  <span className="mt-2">{t('Please wait your data is loading')}</span>
                </td>
                <td className='table-data-row'></td>
                <td className='table-data-row'></td>
                <td className='table-data-row'></td>
              </tr>
            ) : filteredRequests.length === 0 ? (
              <tr>
                <td colSpan="6" className="centered">
                  <Alert variant="light" className='employee-table-Alert'>
                    {t("No employees found")}
                  </Alert>
                </td>
              </tr>
            ) : (
              filteredRequests.map(request => (
                <tr key={request.id}>
                  <td className='A-info'>{request.emp_sap_id}</td>
                  <td className='A-info'>{request.p_name}</td>
                  <td className='A-info'>{request.reason}</td>
                  <td className='A-info'>{request.request_date}</td>
                  <td className={`A-info status-${request.status.toLowerCase()}`}>{t(`status_${request.status.toLowerCase()}`)}</td>
                  <td className='A-info'>
                    {request.status === 'Pending' && (
                      <>
                        <button className="approveButton" onClick={() => handleAccept(request.id, request.employee_id, request.p_name, request.request_date)}>
                          <FontAwesomeIcon icon={faCheck} />
                        </button>
                        <button className="declineButton" onClick={() => handleDecline(request.id)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceRequests;
